/* eslint-disable class-methods-use-this */

import { isTestMode } from '../globals';
import { buildApiRequestContext } from '../helpers/context';
import { getSessionId } from '../helpers/storage';

export enum FeedbackSubjectTypes {
	Intent,
	Article,
}

export interface Feedback {
	id: string;
	messageId: string;
	subjectType: FeedbackSubjectTypes;
	subjectName: string;
	rating?: number;
	relevanceScore?: number;
	detailScore?: number;
	goalScore?: number;
	comments?: string;
}

export class FeedbackService {
	async sendFeedback(data: Feedback): Promise<string> {
		try {
			const response = await fetch(`${CHAT_API_URL}/feedback`, {
				method: 'POST',
				headers: {
					'x-api-key': CHAT_API_KEY,
				},
				body: JSON.stringify({
					...data,
					sessionId: getSessionId(),
					isTestMode,
					requestContext: buildApiRequestContext(),
				}),
			});

			if (!response.ok) {
				return Promise.reject(response.statusText);
			}

			const { id }: Feedback = await response.json();

			return Promise.resolve(id);
		} catch (error) {
			return Promise.reject();
		}
	}
}

export default FeedbackService;
